import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Building2, X } from 'lucide-react'
import { tr } from 'i18n'
import ActorPinField from 'components/Erp/ActorPinField/ActorPinField.tsx'
import BaseSearchSelect from '../Blocks/BaseSearchSelect'
import s from '../Management.module.scss'
import './DriverBaseDialog.scss'

export default function DriverBaseDialog({ driver, mode, busy, error, onClose, onConfirm }: any) {
  useTranslation()
  const currentBaseType = ['top_base', 'chpp', 'private_point'].find(type => driver[type] != null) || ''
  const [baseType, setBaseType] = useState(currentBaseType || 'top_base')
  const [baseId, setBaseId] = useState<number | null>(null)
  const [pin, setPin] = useState('')
  const dialog = useRef<HTMLFormElement>(null)
  useEffect(() => {
    const previous = document.activeElement as HTMLElement
    dialog.current?.focus()
    return () => previous?.focus()
  }, [])
  const title = mode === 'remove' ? 'Снять с базы' : mode === 'change' ? 'Сменить базу' : 'Назначить базу'
  const sameBase = mode === 'change' && currentBaseType === baseType && String(driver[currentBaseType]) === String(baseId)
  const valid = /^[0-9]{4}$/.test(pin) && (mode === 'remove' || (Boolean(baseId) && !sameBase))
  return <div className={s.overlay} onClick={event => event.stopPropagation()}>
    <form className={`${s.dialog} driver-base-dialog`} ref={dialog} tabIndex={-1} role="dialog" aria-modal="true"
      aria-labelledby={`driver-base-title-${driver.id}`}
      onKeyDown={event => { if (event.key === 'Escape' && !busy) onClose() }}
      onSubmit={event => { event.preventDefault(); if (valid && !busy) onConfirm(baseType, baseId, pin) }}>
      <div className="driver-base-dialog__heading">
        <h2 id={`driver-base-title-${driver.id}`}><Building2 size={20} aria-hidden="true" />{tr(title)}</h2>
        <button type="button" className={s.button} aria-label={tr('Закрыть')} disabled={busy} onClick={onClose}><X size={18} aria-hidden="true" /></button>
      </div>
      <div className="driver-base-dialog__vehicle"><strong>{driver.vehicle_number}</strong><span>{driver.employee_name || ''}</span></div>
      {currentBaseType && <p>{tr('Текущая база')}: <strong>{tr(driver.top_base_name || driver.chpp_name || driver.private_point_name || '—')}</strong></p>}
      {error && <div className={s.error} role="alert">{tr(error)}</div>}
      {mode === 'remove' ? <p>{tr('Транспорт останется без базы. Водитель и история перевозок сохранятся.')}</p> :
        <fieldset className="driver-base-dialog__selection" disabled={busy}>
          <label className={s.field}>{tr('Тип базы')}
            <select value={baseType} onChange={event => { setBaseType(event.target.value); setBaseId(null) }}>
              <option value="top_base">{tr('ТОП-База')}</option>
              <option value="chpp">{tr('ТЭЦ')}</option>
              <option value="private_point">{tr('Соц.объект/МСУ')}</option>
            </select>
          </label>
          <div className={s.field}><span>{tr('База')}</span>
            <BaseSearchSelect key={baseType} baseType={baseType} value={baseId} onChange={setBaseId} disabled={busy} activeOnly
              searchAriaLabel={tr('Поиск базы')} selectAriaLabel={tr('База')} style={{ width: '100%', minWidth: 0 }} />
          </div>
        </fieldset>}
      <ActorPinField value={pin} onChange={setPin} disabled={busy} />
      <div className={s.footer}>
        <button type="button" className={s.button} disabled={busy} onClick={onClose}>{tr('Отмена')}</button>
        <button type="submit" className={s.primary} disabled={busy || !valid}>{tr(title)}</button>
      </div>
    </form>
  </div>
}
